<template>
  <div>
    <BreadCrumb class="bread" :breads="['系统管理','帮助文档']"></BreadCrumb>
    <div class="wrap" element-loading-text="加载中">
      <div class="header">
        <span class="nameFt">帮助文档</span>
      </div>
      <div class="submit-form">
        <el-form ref="form" :inline="true" size="small" label-width="80px">
          <div class="submit-form__search">
            <el-form-item label="文档分类">
              <el-select v-model="search.doc_type" placeholder="请选择" clearable>
                <el-option v-for="(item,key) in mode_type" :key="key" :label="item" :value="key"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="文档名称" prop="line">
              <el-input v-model="search.doc_name"></el-input>
            </el-form-item>
            <el-form-item label="文档编号" prop="point">
              <el-input v-model="search.doc_id"></el-input>
            </el-form-item>
          </div>
          <div class="submit-form__operate">
            <el-form-item>
              <el-button type="primary" class="operate-button" @click="searchForm">查询</el-button>
              <el-button type="primary" class="operate-button" @click="reset">重置</el-button>
            </el-form-item>
          </div>
        </el-form>
      </div>

      <div class="table-con">
        <el-table :data="tableList" stripe v-loading="loading">
          <el-table-column label="序号" :index="indexMethod" type="index" align="center"></el-table-column>
          <el-table-column label="文档编号" prop="doc_id" align="center"></el-table-column>
          <el-table-column label="文档分类" prop="doc_type" align="center"></el-table-column>
          <el-table-column label="文档名称" prop="doc_name" align="center"></el-table-column>
          <el-table-column label="文档说明" prop="doc_info" align="center"></el-table-column>
          <el-table-column label="操作" align="center" width="250px">
            <div slot-scope="scope">
              <el-button size="mini" @click="downloadView(scope.row)">下载</el-button>
            </div>
          </el-table-column>
        </el-table>
      </div>
      <div class="paginationWrap">
        <el-pagination @current-change="handleCurrentChange" :page-size="pageSize" :current-page="pageNum" :layout="pageLayout" :total="total"></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
  import BreadCrumb from "@/components/BreadCrumb";
  import apis from "@/config/apis";
  import listMixin from "@/mixins/list";
  import alert from "@/plugins/alert";
  import {
    orderStatus
  } from "@/plugins/enum";
  import {
    download
  } from "@/plugins/util";
  export default {
    name: "CustomerManagement",
    data() {
      return {
        search: {
          doc_type: "",
          doc_name: "",
          doc_id: ""
        },

        mode_type: {
          "": "全部",
          Backstage: "系统后台",
          Program: "小程序",
          Hardware: "硬件故障"
        }
      };
    },
    mixins: [listMixin],
    created() {
      this.search = Object.assign(this.search, this.$route.query);
      this.getData();
    },
    methods: {
    
      getData() {
        const token = localStorage.getItem('token');
      // const headers = {
      //   'Authorization': `Basic ${token}`
      // };
        this.getTableData(apis.help_document, "post", this.search);
      },
      searchForm() {
        this.search.page_index = 1;
        this.getData();
      },
      reset() {
        this.search.page_index = 1;
        this.search = {
          doc_type: "",
          doc_name: "",
          doc_id: ""
        };
        this.getData();
      },

      //下载
      downloadView(data) {
        let jsonDatas = {
          doc_path: data.doc_path
        };
        this.$axios.post(apis.download_document, jsonDatas).then(res => {
          let newUrl = res.data.data.url;
          this.$axios({
            method: "get",
            url: newUrl,
            responseType: "arraybuffer"
          }).then(function(res) {
            // console.log(res,'res')
            let url = window.URL.createObjectURL(new Blob([res.data])); // new Blob([data])用来创建URL的file对象或者blob对象
            // let aa = url.split('pdf')[0];
            // console.log(aa,'aa')
            let link = document.createElement("a");
            link.style.display = "none";
            link.href = url;
            link.download = data.doc_path; //docNumber 动态文件名
            document.body.appendChild(link);
            link.click();
          });
        });
      },
      downloadIamge() {},
      openView(id) {
        this.$router.push({
          name: "logDetail",
          query: {
            id: id
          },
          params: this.search
        });
      },
      exportExcel() {
        download(this, apis.log_export, "系统日志.xls", "get");
      }
    },
    components: {
      BreadCrumb
    }
  };
</script>

<style lang="scss" scoped>
  .operate-con {
    .radio {
      float: right;
      top: 10px;
      right: 10px;
    }
  }
</style>